export default "__VITE_ASSET__Bhwo4oUK__"